import { EntityImage } from '../Entities/EntityImage';
import { PageBlocks } from '../Apps/PageApp';
import '../Apps/AppPage.css';
import './EmbedBlock.css';

// The view renderers the block knows, by app kind. An app instance's embed
// shows its app's one embed view (backend sdk/manifest.py `embed`) below its
// name; an app kind without a renderer here embeds as a plain card.
const VIEWS = {
    page: ({ data, origin }) => <PageBlocks blocks={data.blocks || []} empty="An empty page." linkOrigin={origin} />,
};

const TYPE_LABELS = { context: 'Context', relationship: 'Relationship', person: 'Person', app: 'App' };

/**
 * An entity's embed block, as GET /api/entities/{id}/embed returns it
 * (backend services/embed_blocks.py). Purely presentational: the backend
 * already left out what the admin hid, and `options` says what to draw.
 *
 * `origin` is the web app's address the links point back to; `nodeName`
 * labels the footer. Every link opens a new tab: the block lives inside
 * other sites' frames, where navigating in place would be a dead end.
 */
export function EmbedBlock({ block, origin, nodeName }) {
    const opts = block.options || {};
    const isApp = block.entity_type === 'app';
    const open = `${origin}/${isApp ? 'app' : 'entity'}/${block.id}`;
    const View = isApp && block.view ? VIEWS[block.app_kind] : null;
    const ext = { target: '_blank', rel: 'noopener noreferrer' };

    return (
        <div className="embed-block">
            <div className="embed-block__head">
                {opts.show_picture !== false && <EntityImage entity={block} size={44} />}
                <div className="embed-block__title">
                    <a className="embed-block__name" href={open} {...ext}>{block.name}</a>
                    <span className="t-label-upper" style={{ color: 'var(--text-tertiary)' }}>
                        {isApp && block.app_kind ? block.app_kind : (TYPE_LABELS[block.entity_type] || block.entity_type)}
                    </span>
                </div>
            </div>
            {block.description && <p className="embed-block__description">{block.description}</p>}
            {View && (
                <div className="embed-block__view">
                    <View data={block.view.data} origin={origin} />
                </div>
            )}
            <div className="embed-block__foot">
                <a href={open} {...ext}>{nodeName ? `On ${nodeName}` : 'Open'}</a>
                {block.join_token && (
                    <a className="embed-block__join" href={`${origin}/join/${block.join_token}`} {...ext}>Join</a>
                )}
            </div>
        </div>
    );
}

export default EmbedBlock;
